import ReactSlick from "./ReactSlick/ReactSlick";

const Certifications = () => {
  return <ReactSlick />;
};

export default Certifications;
